import { Injectable } from '@angular/core';
import { TerminalSettingDto } from '@shared/service-proxies/service-proxies';

@Injectable()
export class TerminalSettingsService {

    public _settings: TerminalSettingDto;

    constructor(
    ) {
        this.getSettings();
    }

    //Get current settings
    getSettings(): TerminalSettingDto {

        this._settings = JSON.parse(localStorage.getItem('terminal-settings')) as TerminalSettingDto;

        return this._settings;
    }

    //Set settings
    setSettings(settings: any){

        localStorage.setItem("terminal-settings", JSON.stringify(settings));

        this._settings = settings;
    }

    //Check if config exists
    isConfigured(): boolean{
        return localStorage.getItem('terminal-settings') != null && localStorage.getItem('terminal-settings') != undefined && localStorage.getItem('terminal-settings') != '';
    }

    checkAllowedOnlyAccess(accessType: string): boolean{
        switch(accessType){
            case 'registration':
               return !this._settings.allowCredential && !this._settings.allowCurrentAnnuity && this._settings.allowRegistration;
            case 'annuity':
               return !this._settings.allowCredential && this._settings.allowCurrentAnnuity && !this._settings.allowRegistration;
            case 'credential':
                return this._settings.allowCredential && !this._settings.allowCurrentAnnuity && !this._settings.allowRegistration;
            default:
             return false;


        }
    }

    allowOnlyCredential(): boolean{
        if(this.getSettings()){
           return this._settings.allowCredential && !this._settings.allowCurrentAnnuity && !this._settings.allowRegistration;
        }

        return false;
    }

    allowOnlyAnnuity(): boolean{
        if(this.getSettings()){
           return !this._settings.allowCredential && this._settings.allowCurrentAnnuity && !this._settings.allowRegistration;
        }

        return false;
    }

    allowOnlyRegistrations():boolean{
        if(this.getSettings()){
            return !this._settings.allowCredential && !this._settings.allowCurrentAnnuity && this._settings.allowRegistration;
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/congress/shared/layout/terminal/terminal-settings.service.ts